// language=GraphQL
export const ALL_DIVIDER_BLOCKS_QUERY = `query Query {
  dividerBlocks: cmsDividerBlocks {
    id
    fluid
  }
}`

// language=GraphQL
export const SINGLE_DIVIDER_BLOCK_QUERY = `query Query($id: ID!) {
  dividerBlock: cmsDividerBlock(id: $id) {
    id
    fluid
  }
}`

// language=GraphQL
export const CREATE_DIVIDER_BLOCK_MUTATION = `
  mutation Mutation($input: CreateCmsDividerBlockInput) {
    dividerBlock: createCmsDividerBlock(input: $input) {
      id
      fluid
    }
  }`

// language=GraphQL
export const UPDATE_DIVIDER_BLOCK_MUTATION = `
  mutation Mutation($input: UpdateCmsDividerBlockInput) {
    dividerBlock: updateCmsDividerBlock(input: $input) {
      id
      fluid
    }
  }`

// language=GraphQL
export const DELETE_DIVIDER_BLOCK_MUTATION = `
  mutation Mutation($input: DeleteCmsDividerBlockInput) {
    deleteCmsDividerBlock(input: $input) {
      success
    }
  }`

// language=GraphQL
export const FORCE_DELETE_DIVIDER_BLOCK_MUTATION = `
  mutation Mutation($input: DeleteCmsDividerBlockInput) {
    forceDeleteCmsDividerBlock(input: $input) {
      success
    }
  }`
